import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 38 38"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "18.74",
  cy: "18.899",
  r: "18.637",
  fill: "#ACA199"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#32312F",
  d: "M19.507 28.616h-3.892V19.88H12.7v-3.891h2.91v-.15c0-.77-.014-1.541.006-2.312.025-.971.267-1.884.856-2.678.563-.759 1.321-1.225 2.225-1.474.475-.13.96-.185 1.451-.188.851-.006 1.7.039 2.547.118.041.003.082.01.131.015v3.081c-.038.003-.074.006-.11.006-.57 0-1.14-.004-1.71.004-.204 0-.409.02-.61.059-.557.11-.83.403-.864.97-.032.534-.023 1.07-.03 1.605-.003.307 0 .614 0 .936h3.422c-.018.176-.033.337-.052.497l-.34 2.974c-.012.105-.033.21-.037.316-.003.083-.03.11-.114.108-.448-.004-.896-.002-1.345-.002H19.51l-.002 8.742Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }